import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { progressApi } from '../../api/client';
import styles from '../../styles/Layout.module.css';
function getXpForLevel(level) {
    if (level <= 1)
        return 0;
    return 100 * (level - 1) * level / 2;
}
export function XpBar() {
    const [xp, setXp] = useState(0);
    const [level, setLevel] = useState(1);
    const location = useLocation();
    useEffect(() => {
        progressApi.getSummary().then((data) => {
            setXp(data.stats.totalXp);
            setLevel(data.stats.level);
        }).catch(() => { });
    }, [location.pathname]);
    const xpForCurrent = getXpForLevel(level);
    const xpForNext = getXpForLevel(level + 1);
    const xpInLevel = xp - xpForCurrent;
    const xpNeeded = xpForNext - xpForCurrent;
    const pct = xpNeeded > 0 ? Math.min(100, (xpInLevel / xpNeeded) * 100) : 100;
    return (_jsxs("div", { className: styles.xpContainer, children: [_jsxs("span", { className: styles.xpLevel, children: ["Lv.", level] }), _jsx("div", { className: styles.xpTrack, children: _jsx("div", { className: styles.xpFill, style: { width: `${pct}%` } }) }), _jsxs("span", { className: styles.xpTotal, children: [xp, " XP"] })] }));
}
